import React from 'react';
import { TableCell } from '@mui/material';

export type TCustomTableHeadCellTextAlign = 'left' | 'center' | 'right';

interface ICustomTableHeadCellProps {
    children?: React.ReactNode;
    width?: number;
    onClick?: () => void;
    // Defaults to 'center' so direct callers keep the old look; CTableWrapper
    // passes each column's alignment so the header lines up with its body cells.
    textAlign?: TCustomTableHeadCellTextAlign;
}

export function DTableHeadCell({
    children,
    width,
    onClick,
    textAlign = 'center',
}: ICustomTableHeadCellProps) {
    return (
        <TableCell
            sx={{
                textAlign,
                width: width ? `${width}%` : 'initial',
                fontWeight: 700,
                color: onClick ? 'primary.main' : 'inherit',
                cursor: onClick ? 'pointer' : 'inherit',
            }}
            onClick={onClick}
        >
            {children}
        </TableCell>
    );
}
